import { render, staticRenderFns } from "./SalesAccountList.vue?vue&type=template&id=6b6b205c&"
import script from "./SalesAccountList.vue?vue&type=script&lang=js&"
export * from "./SalesAccountList.vue?vue&type=script&lang=js&"
import style0 from "./SalesAccountList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports